export default "__VITE_ASSET__CyKKgXLj__"